export default __webpack_public_path__ + "static/media/DonorNearYou.716f409d.svg";